import request from '@/src/apis/axios';
import {
  DeleteDonationByIdRequestBody,
  GetDonationsRequestParams,
  GetDonationParticipantsRequestParams,
  PostDonationRequestBody,
  PutDonationRequestBody,
} from '@/src/apis/rest/donation.dtos';
import DonationDto from '@/src/models/DonationDto';
import DonationParticipantDto from '@/src/models/DonationParticipantDto';
import { ListResponse, ObjectResponse } from '@/src/types/common';
import { plainToInstance } from 'class-transformer';

const URL = {
  donation: '/admin/donations',
  donationDetail: '/admin/donations/{id}',
  donationParticipants: '/admin/donation-participants',
  donationParticipantsExcel: '/admin/donation-participants/excel-export',
  donationsExcel: '/admin/donations/excel/export',
};
// 기부하기 리스트 조회
export const getDonationsAPI = async (
  queryParams: Partial<GetDonationsRequestParams>,
) => {
  const { data } = await request<ListResponse<DonationDto>>({
    method: 'get',
    url: URL.donation,
    queryParams,
  });

  const rows = plainToInstance(DonationDto, data.rows);

  return { rows, count: data.count };
};
// 기부하기 상세 조회
export const getDonationByIdAPI = async (id: number) => {
  const { data } = await request<ObjectResponse<DonationDto>>({
    method: 'get',
    url: URL.donationDetail.replace('{id}', String(id)),
  });

  return plainToInstance(DonationDto, data.row);
};

// 기부하기 생성
export const postDonationAPI = async (requestBody: PostDonationRequestBody) => {
  const { data } = await request<ObjectResponse<DonationDto>>({
    method: 'post',
    url: URL.donation,
    requestBody: { ...requestBody },
  });

  return plainToInstance(DonationDto, data.row);
};
// 기부하기 수정
export const putDonationAPI = async (requestBody: PutDonationRequestBody) => {
  const { id, ...rest } = requestBody;

  const { data } = await request<ObjectResponse<DonationDto>>({
    method: 'put',
    url: URL.donationDetail.replace('{id}', String(id)),
    requestBody: { ...rest },
  });

  return plainToInstance(DonationDto, data.row);
};
// 기부하기 삭제
export const DeleteDonationByIdAPI = async ({
  id,
}: DeleteDonationByIdRequestBody) => {
  const { data } = await request<ObjectResponse<DonationDto>>({
    method: 'delete',
    url: URL.donationDetail.replace('{id}', String(id)),
  });

  return plainToInstance(DonationDto, data.row);
};

// 기부하기 참여 회원 리스트 조회
export const getDonationParticipantsAPI = async (
  requestParams: Partial<GetDonationParticipantsRequestParams>,
) => {
  const { page = 1, pageSize = 10, ...rest } = requestParams;

  const { data } = await request<ListResponse<DonationParticipantDto>>({
    method: 'get',
    url: URL.donationParticipants,
    queryParams: { page, pageSize, ...rest },
  });

  const rows = plainToInstance(DonationParticipantDto, data.rows);

  return { rows, count: data.count };
};

// 기부하기 참여 회원 리스트 엑셀 다운로드
export const getDonationParticipantsExcelAPI = async (
  password: string,
  requestParams: Partial<GetDonationParticipantsRequestParams>,
) => {
  const { data } = await request<Blob>({
    method: 'get',
    url: URL.donationParticipantsExcel,
    queryParams: { password, ...requestParams },
    config: { responseType: 'blob' },
  });

  return data;
};

export const getDonationsExcelAPI = async (
  password: string,
  requestParams: Partial<GetDonationsRequestParams>,
) => {
  const { data } = await request<Blob>({
    method: 'get',
    url: URL.donationsExcel,
    queryParams: { password, ...requestParams },
    config: { responseType: 'blob' },
  });

  return data;
};
